// reset
import 'normalize.css'
import '@/assets/css/theme/b2b.scss'
import '@/assets/css/theme/d2c.scss'

// 加载css文件列表
const includes = []
const requireContext = require.context('./', false, /\.(c|sa|sc)ss$/)

requireContext.keys().forEach((fileName) => {
  if (includes.length) {
  } else {
    requireContext(fileName)
  }
})
